<template>
  <div class="min-h-screen bg-gray-50 px-4 py-6 pb-28" dir="rtl">
    <div class="max-w-2xl mx-auto space-y-6">
      
      <!-- Header Card -->
      <div class="bg-gradient-to-r from-green-600 to-green-700 rounded-xl p-6 text-white">
        <div class="flex items-center gap-3">
          <div class="w-14 h-12 rounded-full bg-white bg-opacity-20 backdrop-blur-sm flex items-center justify-center">
            <svg class="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
            </svg>
          </div>
          <div class="w-full">
            <h2 class="text-xl font-bold">اطلاعات اولیه</h2>
            <p class="text-sm text-green-50">لطفاً اطلاعات درخواست را تکمیل کنید</p>
          </div>
        </div>
      </div>

      <!-- Form Card -->
      <div class="bg-white rounded-xl border border-gray-200 p-6 space-y-6">
        
        <!-- Price & Currency -->
        <div class="grid grid-cols-3 gap-4">
          <div class="col-span-2">
            <label class="block text-sm font-medium text-gray-700 mb-2">{{ $t('priceNotReq') }}</label>
            <input
              v-model="price"
              type="tel"
              inputmode="numeric"
              pattern="[0-9]*"
              class="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-green-500"
              style="border: 1px solid #d1d5db !important;"
              placeholder="مثلاً 1,000,000"
            />
          </div>
          <div class="relative">
            <label class="block text-sm font-medium text-gray-700 mb-2">{{ $t('select') }}</label>
            <select
              v-model="selected_currency"
              class="w-full px-4 py-3 pl-5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-green-500 appearance-none"
              style="border: 1px solid #d1d5db !important;"
            >
              <option v-for="curr in currency_items" :key="curr.value" :value="curr.value">
                {{ curr.label }}
              </option>
            </select>
            <!-- Dropdown Icon -->
            <div class="absolute left-3 top-43px pointer-events-none">
              <svg class="w-5 h-5 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7" />
              </svg>
            </div>
          </div>
        </div>

        <!-- Repair Days -->
        <div>
          <label class="block text-sm font-medium text-gray-700 mb-2">زمان حدودی تعمیر (روز)</label>
          <input
            v-model="tamir_days"
            inputmode="numeric"
            type="number"
            class="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-green-500"
            style="border: 1px solid #d1d5db !important;"
            placeholder="روز"
          />
        </div>

        <!-- Pre-defined Items -->
        <div v-if="pre_defined_items.length > 0" class="space-y-4">
          <h3 class="text-lg font-bold text-gray-900">ویژگی‌های اضافی</h3>
          
          <div v-for="item in pre_defined_items" :key="item.TextId" class="space-y-2">
            
            <!-- Checkbox Items -->
            <div 
              v-if="item.PredefineTypeId == 1" 
              @click="item.IsChecked = !item.IsChecked"
              :class="item.IsChecked ? 'bg-green-50 border-green-300' : 'bg-gray-50 border-gray-200'"
              class="flex items-center gap-3 p-3 rounded-lg border cursor-pointer hover:shadow-md transition-all duration-200"
            >
              <div class="flex items-center gap-3 w-full">
                <label class="text-sm font-medium text-gray-900 cursor-pointer">{{ item.Text }}</label>
              </div>
              <div 
                :class="item.IsChecked ? 'bg-green-600 border-green-600' : 'bg-white border-gray-300'"
                class="w-6 h-6 border rounded-md flex flex-shrink-0 items-center justify-center transition-all duration-200"
              >
                <svg v-if="item.IsChecked" class="w-4 h-4 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="3" d="M5 13l4 4L19 7" />
                </svg>
              </div>
            </div>

            <!-- Text Input Items -->
            <div v-if="item.PredefineTypeId == 2">
              <label class="block text-sm font-medium text-gray-700 mb-2">{{ item.Text }}</label>
              <input
                v-model="item.Value"
                type="text"
                class="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-green-500"
                style="border: 1px solid #d1d5db !important;"
                :placeholder="item.Text"
              />
            </div>
          </div>
        </div>

        <!-- Device Password -->
        <div>
          <label class="block text-sm font-medium text-gray-700 mb-2">{{ $t('devicePassword') }}</label>
          <input
            v-model="device_password"
            type="text"
            class="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-green-500"
            style="border: 1px solid #d1d5db !important;"
            placeholder="رمز عبور دستگاه"
          />
        </div>

      </div>

      <!-- Submit Button -->
      <button 
        @click="go_to_details()"
        class="w-full bg-gradient-to-r from-green-600 to-green-700 hover:from-green-700 hover:to-green-800 text-white py-4 px-6 rounded-xl font-bold transition-all duration-200 flex items-center justify-center gap-2"
      >
        {{ $t('add_information') }}
        <svg class="w-5 h-5 rotate-180" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13 7l5 5m0 0l-5 5m5-5H6" />
        </svg>
      </button>

    </div>
  </div>
</template>
<script>
  import { bus } from '../../main.js'

  export default {
    props: [
      'passing_data'
    ],
    data () {
      return {
        tamir_days:'',
        errors: [],
        currency_items: [],
        selected_currency: 0,
        price: '',
        branch_id: 0,
        // device_serial_number: '',
        device_password: '',
        pre_defined_items: [],

        valid: true,
        not_register: false,
        user_registered: false,

      }
    },
watch: {
      price() {
        const formatted = this.formatAmountInput(this.price)
        if (this.price !== formatted) {
          this.price = formatted
        }
      },
    },
mounted () {
      this.get_currencies()
      this.get_branch_permission()
      this.get_predifined()
    },
    methods: {
      go_to_details () {
        // var PassingData = {'on_site_service':OnSite}
        // if (this.fullName != '') {
        var passing_data = JSON.parse(localStorage.getItem('request_data'))
        passing_data.device_password = this.device_password
        passing_data.price = this.parseAmountInput(this.price)
        passing_data.currency = this.selected_currency
        passing_data.branch_id = this.branch_id
        passing_data.tamir_days = this.tamir_days
        // passing_data.device_serial_number = this.device_serial_number;
        passing_data.pre_defined = JSON.stringify(this.pre_defined_items)
        localStorage.setItem('request_data', JSON.stringify(passing_data))
        this.$router.push({ name: 'request_detail', params: {} })
        // } else {
        //   bus.$emit('show_dialog', ["خطا", "لطفا شماره مشتری را وارد کنید"])
        //
        // }
      },
      get_currencies () {
        var self = this
        var user_id = JSON.parse(localStorage.getItem('profile')).UserId
        console.log()
        const send_data = {
          UserId: user_id,
        }
        // this.axios.post('/Register' , send_data,{
        this.axios.post('/GetCurrencies', send_data, {})
          .then(response => {
            if (response.data.error == 0) {
              response.data.Currencies.forEach(function (number) {
                if (number.CurrencyName == self.$t('currencyName')) {
                  self.selected_currency = number.CurrencyId
                }
                var obj = { label: number.CurrencyName, value: number.CurrencyId }
                self.currency_items.push(obj)
              })
              // response.data.parties.forEach(function(item) {
              //   console.log("sdsd"+item)
              //
              // });
            }
          }).catch(e => {
          this.errors.push(e)
        })
      },
      get_branch_permission () {
        var self = this
        var user_id = JSON.parse(localStorage.getItem('profile')).UserId
        var party_id = localStorage.getItem('party_id')

        const send_data = {
          UserId: user_id,
          Role: 'BranchDefinition',
          PartyId: party_id,
        }
        // this.axios.post('/Register' , send_data,{
        this.axios.post('/ZkGetUserPermission', send_data, {})
          .then(response => {
            if (response.data.error == 0) {
             this.branch_id = response.data.UserBranchId
            }
          }).catch(e => {
          this.errors.push(e)
        })
      },

      get_predifined () {
        var self = this
        var passing_data = JSON.parse(localStorage.getItem('request_data'))
        var user_id = passing_data.UserId
        var typeId = passing_data.cat_id
        var catId = passing_data.group_id
        var subcatId = passing_data.sub_group_id
        var brandId = passing_data.brand_id
        var DeviceModel = passing_data.device_model

        const send_data = {
          TypeId: typeId,
          CatId: catId,
          GroupId: subcatId,
          BrandId: brandId,
          Model: DeviceModel,
          Phone: DeviceModel,
        }
        // this.axios.post('/Register' , send_data,{
        this.axios.post('/PredefinedText', send_data, {})
          .then(response => {
            if (response.data.error == 0) {
self.pre_defined_items = response.data.PredefinedList
            }
          }).catch(e => {
          this.errors.push(e)
        })
      },

    }
  }
</script>
<style>

  </style>